import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import TabTable from '../TabTable'

const COLUMNS = [
  { key: 'id', label: 'Transaction ID' },
  { key: 'user', label: 'User' },
  { key: 'type', label: 'Type' },
  { key: 'amount', label: 'Amount' },
  {
    key: 'status',
    label: 'Status',
    render: (row) => (
      <span className={`px-2 py-0.5 rounded text-xs font-medium ${
        row.status === 'Successful' ? 'bg-success bg-opacity-10 text-success'
          : row.status === 'Failed' ? 'bg-danger bg-opacity-10 text-danger'
            : 'bg-orange-500 bg-opacity-10 text-orange-500'
      }`}
      >
        {row.status}
      </span>
    )
  },
  { key: 'date', label: 'Date & Time' }
]

const STATUS_OPTIONS = [
  { label: 'All statuses', value: '' },
  { label: 'Successful', value: 'Successful' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Failed', value: 'Failed' }
]

export default function TransactionsTab({ campaign }) {
  const { transactions } = campaign

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {
          transactions.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilExchange} label={stat.label} value={stat.value} suffix={stat.suffix} tone={stat.tone} />
          ))
        }
      </div>

      <TabTable
        columns={COLUMNS}
        rows={transactions.rows}
        searchPlaceholder="Search by transaction ID, user"
        searchKeys={['id', 'user']}
        statusOptions={STATUS_OPTIONS}
      />
    </div>
  )
}
